@if (displayOnly) {
  <div class="display-only" [class.highlight]="hasSubIssue">
    @if (isCurrency && displayValue) {
      <span>$&nbsp;</span>
    }
    <span>{{ displayValue }}</span>
  </div>
}
@if (!displayOnly) {
  <mat-form-field
    appearance="outline"
    class="width-auto"
    [class.highlight]="hasSubIssue"
  >
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      matInput
      type="text"
      title="{{ label }}"
      [formControl]="numberControl"
      (change)="onChange()"
      (blur)="onTouched()"
      (keyup)="onChange()"
      [required]="required"
    />
    @if (isCurrency) {
      <span matPrefix>$&nbsp;</span>
    }
    @if (hasError('required')) {
      <mat-error> {{ getLabel() }} is required. </mat-error>
    }
    @if (hasError('minimumValue')) {
      <mat-error> Must be greater than {{ min }}. </mat-error>
    }
    @if (hasError('maximumValue')) {
      <mat-error> Must be less than {{ max }}. </mat-error>
    }
    @if (hasError('numericValue')) {
      <mat-error> Must be a numeric value. </mat-error>
    }
    @if (hasError('positiveNumber')) {
      <mat-error> Must be a positive number. </mat-error>
    }
  </mat-form-field>
}
